import { Link } from "react-router-dom"
import { formatDate } from "../utils/text.js"

const SitemapPage = ({ text, language }) => {
    // Get the current language code from the language setting
    const currentLang = language.split('-')[0].toLowerCase()

    // Structure your routes into categories for better organization
    const siteStructure = [
        {
            category: text.sitemapMainCategory || "Main Pages",
            routes: [
                { path: `/${currentLang}`, label: text.navHome || "Home" }
            ]
        },
        {
            category: text.sitemapAboutCategory || "About Us",
            routes: [
                { path: `/${currentLang}/family`, label: text.navHomepageTheFamily || "Family" },
                { path: `/${currentLang}/history`, label: text.navHomepageHistory || "History" }
            ]
        },
        {
            category: text.sitemapNatureCategory || "Nature & Environment",
            routes: [
                { path: `/${currentLang}/animals`, label: text.navHomepageAnimals || "Animals" },
                { path: `/${currentLang}/environment`, label: text.navHomepageEnvironment || "Environment" },
                { path: `/${currentLang}/sheep`, label: text.navSheep || "Sheep" }
            ]
        },
        {
            category: text.sitemapAccommodationCategory || "Accommodation",
            routes: [
                { path: `/${currentLang}/apartments`, label: text.navApartmentsApartments || "Apartments" },
                { path: `/${currentLang}/prices`, label: text.navApartmentsPrices || "Prices" },
                { path: `/${currentLang}/services`, label: text.navApartmentsServices || "Services" },
                { path: `/${currentLang}/bookroom`, label: text.navBookRoom || "Book a Room" }
            ]
        },
        {
            category: text.sitemapVisitCategory || "Visiting Us",
            routes: [
                { path: `/${currentLang}/arrival`, label: text.navArrival || "Arrival" },
                { path: `/${currentLang}/contact`, label: text.navContact || "Contact" }
            ]
        },
        {
            category: text.sitemapLegalCategory || "Legal Information",
            routes: [
                { path: `/${currentLang}/privacy`, label: text.footerPrivacy || "Privacy Policy" },
                { path: `/${currentLang}/legalinfo`, label: text.footerLegalNotes || "Legal Information" }
            ]
        }
    ]

    return (
        <div className="drocker-body drocker-no-image">
            <div className="container my-5">
                <h1 className="mb-4">{text.sitemapTitle || "Sitemap"}</h1>
                <p className="lead mb-5">{text.sitemapDescription || "Here you can find an overview of all pages on our website."}</p>
                <div className="row">
                    {siteStructure.map((category, index) => (
                        <div key={index} className="col-md-6 col-lg-4 mb-4">
                            <div className="card h-100">
                                <div className="card-header">
                                    <h2 className="h5 mb-0">{category.category}</h2>
                                </div>
                                <div className="card-body">
                                    <ul className="list-unstyled mb-0">
                                        {category.routes.map((route, routeIndex) => (
                                            <li key={routeIndex} className="mb-2">
                                                <Link to={route.path} className="text-decoration-none">
                                                    {route.label}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-5 text-center">
                    <p className="text-muted small">
                        {text.sitemapLastUpdated || "Last updated"}: {formatDate(new Date(), language)}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default SitemapPage
